import React, { useState } from 'react';
import { FaPlay, FaClock } from 'react-icons/fa';
import Modal from '../shared/Modal';
import './DeployModal.css';

const DeployModal = ({ isOpen, onClose, onDeploy, customAgentName }) => {
  const [deploymentType, setDeploymentType] = useState('immediate');
  const [scheduleType, setScheduleType] = useState('cron');
  const [cronExpression, setCronExpression] = useState('0 9 * * 1'); // Default: Every Monday at 9 AM
  const [interval, setInterval] = useState('1h');
  const [timezone, setTimezone] = useState('America/New_York');

  const handleDeploy = () => {
    const deploymentConfig = {
      executionMode: deploymentType,
      schedule: deploymentType === 'scheduled' ? {
        type: scheduleType,
        value: scheduleType === 'cron' ? cronExpression : interval,
        timezone: timezone
      } : null
    };

    onDeploy(deploymentConfig);
  };

  const cronPresets = [
    { label: 'Every Monday at 9 AM', value: '0 9 * * 1' },
    { label: 'Every Day at 9 AM', value: '0 9 * * *' },
    { label: 'Every Hour', value: '0 * * * *' },
    { label: 'Every 15 Minutes', value: '*/15 * * * *' },
    { label: 'First Day of Month at 9 AM', value: '0 9 1 * *' }
  ];

  const intervalPresets = [
    { label: 'Every 15 minutes', value: '15m' },
    { label: 'Every 30 minutes', value: '30m' },
    { label: 'Every hour', value: '1h' },
    { label: 'Every 6 hours', value: '6h' },
    { label: 'Every day', value: '24h' }
  ];

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Deploy CustomAgent" size="medium">
      <div className="deploy-modal">
        <div className="deploy-intro">
          <p>Choose how you want to deploy <strong>{customAgentName}</strong></p>
        </div>

        <div className="deployment-types">
          <div
            className={`deployment-option ${deploymentType === 'immediate' ? 'selected' : ''}`}
            onClick={() => setDeploymentType('immediate')}
          >
            <div className="option-icon">
              <FaPlay />
            </div>
            <div className="option-content">
              <h4>Run Now</h4>
              <p>Activate immediately and run based on triggers</p>
            </div>
            <div className="option-radio">
              <input
                type="radio"
                checked={deploymentType === 'immediate'}
                onChange={() => setDeploymentType('immediate')}
              />
            </div>
          </div>

          <div
            className={`deployment-option ${deploymentType === 'scheduled' ? 'selected' : ''}`}
            onClick={() => setDeploymentType('scheduled')}
          >
            <div className="option-icon">
              <FaClock />
            </div>
            <div className="option-content">
              <h4>Schedule for Later</h4>
              <p>Run automatically on a recurring schedule</p>
            </div>
            <div className="option-radio">
              <input
                type="radio"
                checked={deploymentType === 'scheduled'}
                onChange={() => setDeploymentType('scheduled')}
              />
            </div>
          </div>
        </div>

        {deploymentType === 'scheduled' && (
          <div className="schedule-config">
            <div className="schedule-type-tabs">
              <button
                className={`tab-button ${scheduleType === 'cron' ? 'active' : ''}`}
                onClick={() => setScheduleType('cron')}
              >
                Cron Expression
              </button>
              <button
                className={`tab-button ${scheduleType === 'interval' ? 'active' : ''}`}
                onClick={() => setScheduleType('interval')}
              >
                Simple Interval
              </button>
            </div>

            {scheduleType === 'cron' ? (
              <div className="schedule-fields">
                <div className="form-group">
                  <label>Cron Expression</label>
                  <input
                    type="text"
                    value={cronExpression}
                    onChange={(e) => setCronExpression(e.target.value)}
                    placeholder="0 9 * * 1"
                  />
                  <small className="help-text">Format: minute hour day month weekday</small>
                </div>

                <div className="form-group">
                  <label>Quick Presets</label>
                  <select
                    value={cronExpression}
                    onChange={(e) => setCronExpression(e.target.value)}
                  >
                    {cronPresets.map((preset) => (
                      <option key={preset.value} value={preset.value}>
                        {preset.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            ) : (
              <div className="schedule-fields">
                <div className="form-group">
                  <label>Run Every</label>
                  <select
                    value={interval}
                    onChange={(e) => setInterval(e.target.value)}
                  >
                    {intervalPresets.map((preset) => (
                      <option key={preset.value} value={preset.value}>
                        {preset.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="form-group">
              <label>Timezone</label>
              <select
                value={timezone}
                onChange={(e) => setTimezone(e.target.value)}
              >
                <option value="America/New_York">Eastern Time (ET)</option>
                <option value="America/Chicago">Central Time (CT)</option>
                <option value="America/Denver">Mountain Time (MT)</option>
                <option value="America/Los_Angeles">Pacific Time (PT)</option>
                <option value="America/Phoenix">Arizona (MST)</option>
                <option value="Europe/London">London (GMT)</option>
                <option value="Europe/Paris">Paris (CET)</option>
                <option value="Asia/Tokyo">Tokyo (JST)</option>
                <option value="Asia/Shanghai">Shanghai (CST)</option>
                <option value="Australia/Sydney">Sydney (AEST)</option>
              </select>
            </div>
          </div>
        )}

        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-primary" onClick={handleDeploy}>
            <FaPlay /> Deploy CustomAgent
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeployModal;

